import { Box, TextField } from "@mui/material";
import { Form, useLoaderData } from "react-router-dom";
import { Result } from "../../types/Result";
import { Jeton } from "./type";

export default function JetonForm() {
  const data = useLoaderData() as Result<Jeton>;
  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Form method="post">
        <TextField
          placeholder="Id"
          type="text"
          name="id"
          value={data.data?.totalJeton}
          fullWidth
          margin="dense"
          label="Id"
          disabled
        />
      </Form>
    </Box>
  );
}
